import type { Folder } from '../folders/types';
import type { Group } from './types';
import { useI18n } from '@/core/plugins/i18n';
import { folderDefault } from '../folders/utils';
import { ITEM_ID_ALL } from '@/components/formsExt/selector2/utils';

/**
 * Элемент - группа ненайдена
 *
 * Указывается несуществующий id
 */
export const groupNone: Group = {
	id: -1,
	name: '--',
	folder_id: folderDefault.id,
	folder_path: folderDefault.path,
};

/**
 * Элемент для выбора всех групп
 */
export const groupAll: Group = {
	id: ITEM_ID_ALL,
	name: 'All groups',
	folder_id: folderDefault.id,
	folder_path: folderDefault.path,
};

/**
 * Элемент - `Все группы`
 */
export const genGroupAll = () => {
	groupAll.name = useI18n()?.Common.All_groups;

	return groupAll;
};

/**
 * Элемент - `Выберите группу`
 */
export const genGroupPlaceholder = () => {
	groupAll.name = useI18n()?.Keywords.Choose_group;

	return groupAll;
};

/**
 * Сгенерировать список групп для TopSelector
 */
export const genItems = (groups: Group[], on?: boolean, folderForFilter?: Folder) => {
	groups = [...groups];

	// фильтр по активности
	if (on !== undefined) {
		groups = groups.filter((group) => {
			return group.on == Number(on);
		});
	}

	// фильтр по папке
	if (folderForFilter && folderForFilter.id && folderForFilter.childsIds) {
		groups = groups.filter((group) => {
			return (
				group.folder_id === folderForFilter.id ||
				folderForFilter.childsIds!.includes(group.folder_id)
			);
		});
	}

	return groups;
};

/**
 * Создать API запрос на получение групп
 */
export const genApiGetGroups = (client: Api.Client<Api.TV.Paths, true>) => {
	return client.gen('/get/keywords_2/groups/', ['id', 'name', 'folder_id', 'folder_path']).changeParams({ folder_id_depth: true, limit: 100 });
};

/**
 * Создать API запрос на получение групп
 */
export const genApiAddGroup = (client: Api.Client<Api.TV.Paths, true>) => {
	return client.gen('/add/keywords_2/groups/');
};
